// @flow
import { CampaignActionTypes } from './actionTypes';

const initialState = {
  campaignDetails: null,
  loading: {
    campaignDetails: false,
  },
  error: {
    campaignDetails: false,
  },
};

const CampaignPageReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case CampaignActionTypes.CAMPAIGNBANNER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, campaignDetails: true },
        error: { ...state.error, campaignDetails: null },
      };
    case CampaignActionTypes.CAMPAIGNBANNER.SUCCESS:
      return {
        ...state,
        campaignDetails: payload,
        loading: { ...state.loading, campaignDetails: false },
      };
    case CampaignActionTypes.CAMPAIGNBANNER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, campaignDetails: false },
        error: { ...state.error, campaignDetails: payload },
      };
    default:
      return state;
  }
};

export default CampaignPageReducer;
